<!--
 * @Description: 环境监测
 * @Autor: wangwangwang
 * @Date: 2021-03-05 16:30:56
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-03-08 13:59:26
-->
<template>
  <div class="pages_content table">
    <!-- 新需求 -->
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex;flex-direction:column">
        <div class="header_right">
          <div style="display: flex;align-items: center">
            <span style="font-size: 18px;">站点：崇州站</span>
          </div>
          <el-button size="small" class="bottom_all" style="margin-left: 12px" @click="infoHistory">数据历史</el-button>
        </div>
        <div class="monitoring scroll">
          <list-first class="listItem" title="料仓环境监测" :dataInfo="dataInfo1" />
          <list-first class="listItem" title="浆水池环境监测" :dataInfo="dataInfo2" />
          <list-first class="listItem" title="主机楼环境监测" :dataInfo="dataInfo3" />
          <main-table class="listItem" :dataInfo="dataInfo4" />
          <list-second class="listItem" title="浆水池固含量监测" :dataInfo="dataInfo5" />
          <list-second class="listItem" title="外加剂罐监测" :dataInfo="dataInfo6" />
        </div>
      </el-main>

      <history-dialog :visible="historyVisible" @historyChange="historyChange" />
    </el-container>
  </div>
</template>
  
<script>
import breaDcrumb from "@/components/breadcrumb";
import listFirst from "./listFirst.vue";
import mainTable from "./mainTable.vue";
import listSecond from "./listSecond.vue";
import historyDialog from "./dialog.vue";
import mixin from "@/mixins/ICPSmixin.js";
import { getNewList } from '@/api/smart/environmentalMonitor.js'

export default {
  components: {
    breaDcrumb,
    listFirst,
    listSecond,
    mainTable,
    historyDialog
  },
  mixins: [mixin],
  data() {
    return {
      historyVisible: false,
      siteList: [],
      monitoringList: [1, 5, 4, 5],
      styleStatus: false,

      websock: null,
      dataInfo1: {},
      dataInfo2: {},
      dataInfo3: {},
      dataInfo4: [{ groupName: '1号主机能耗监测' }, { groupName: '1号斜皮带能耗监测' }, { groupName: '1号平皮带能耗监测' }, { groupName: '2号主机能耗监测' }, { groupName: '2号斜皮带能耗监测' }, { groupName: '2号平皮带能耗监测' }],
      dataInfo5: {},
      dataInfo6: {},
    };
  },
  watch: {
    dataInfo4: {
      handler(val) {
        this.dataInfo4 = val
      },
      deep: true
    }
  },
  created() {
    if (this.websock) {
      this.websock.onclose();
    }
    this.initWebSocket();
    this.getNewList()
  },
  methods: {
    infoHistory() {
      this.historyVisible = true
    },
    getNewList() {
      getNewList().then(res => {
        if (res.data.length) {
          res.data.forEach(item => {
            if (item.groupName === '1号主机能耗监测') {
              this.$set(this.dataInfo4, 0, item)
            } else if (item.groupName === '2号主机能耗监测') {
              this.$set(this.dataInfo4, 3, item)
            } else if (item.groupName === '1号斜皮带能耗监测') {
              this.$set(this.dataInfo4, 1, item)
            } else if (item.groupName === '2号斜皮带能耗监测') {
              this.$set(this.dataInfo4, 4, item)
            } else if (item.groupName === '1号平皮带能耗监测') {
              this.$set(this.dataInfo4, 2, item)
            } else if (item.groupName === '2号平皮带能耗监测') {
              this.$set(this.dataInfo4, 5, item)
            }
          })
        }
      })
    },
    historyChange() {
      this.historyVisible = false
    },
    initWebSocket() { //初始化weosocket
      // const wsuri = `${process.env.VUE_APP_API_WSS}mqttwebsocket/`;//这个必须域名连接，否则跨域,域名连接不上就服务器转两次就好了
      const wsuri = `wss://lvshe.huashijc.com/mqttwebsocket`;//这个必须域名连接，否则跨域,域名连接不上就服务器转两次就好了
      // const wsuri = `ws://182.150.57.81:28290/websocket`;//这个必须域名连接，否则跨域,域名连接不上就服务器转两次就好了
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketonclose;
    },
    websocketonerror() {//连接建立失败重连
      let _this = this
      if (this.count == 0) {
        this.count++
        clearInterval(_this.setTime)
        _this.setTime = setTimeout(function () {
          _this.initWebSocket();
          // _this.$message.error("服务断开,重新连接中。。。")
          this.count = 0
        }, 5000)
      }
    },
    websocketonclose() {

    },
    websocketonmessage(e) { //数据接收
      const _this = this
      switch (JSON.parse(e.data)._groupName) {
        case '浆水固含量':
          _this.dataInfo5 = JSON.parse(e.data)
          break;

        case '料仓环境监测':
          _this.dataInfo1 = JSON.parse(e.data)
          break;

        case '浆水池环境监测':
          _this.dataInfo2 = JSON.parse(e.data)
          break;

        case '主机楼环境监测':
          _this.dataInfo3 = JSON.parse(e.data)
          break;

        case '外加剂罐':
          _this.dataInfo6 = JSON.parse(e.data)
          break;

        case '1号主机能耗监测':
          console.log(e, '------------');
          this.$set(this.dataInfo4, 0, JSON.parse(e.data))
          break;

        case '2号主机能耗监测':
          this.$set(this.dataInfo4, 3, JSON.parse(e.data))
          break;

        case '1号斜皮带能耗监测':
          this.$set(this.dataInfo4, 1, JSON.parse(e.data))
          break;

        case '2号斜皮带能耗监测':
          this.$set(this.dataInfo4, 4, JSON.parse(e.data))
          break;

        case '1号平皮带能耗监测':
          this.$set(this.dataInfo4, 2, JSON.parse(e.data))
          break;

        case '2号平皮带能耗监测':
          this.$set(this.dataInfo4, 5, JSON.parse(e.data))
          break;

        default:
          break;
      }
    },
    websocketonopen() {
    },
  },
  beforeDestroy() {
    if (this.websock) {
      this.websock.close();
      this.websock.onclose = function() {
        console.log("websocket已关闭"); 
      };
    }
    window.removeEventListener('beforeunload', () => {
      if (this.websock) {
        this.websock.close();
        this.websock.onclose = function() {
          console.log("websocket已关闭"); 
        };
      }
    })
  },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
  width: 240px;
}

.monitoring {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  padding: 0 6px 0px 6px;
  justify-content: space-between;

  .listItem {
    width: 48%;
    height: 32%;
  }

  /**
    display: grid;
    padding: 20px;
    box-sizing: border-box;
    grid-template-columns: repeat(2, 50%);
    grid-template-rows: repeat(3, 33.33%);
    grid-row-gap: 20px;
    grid-column-gap: 40px;
    **/
}

.header_right {
  margin: 20px;
  box-sizing: border-box;
  border: 1px solid #f1f1f1;
  display: flex;
  align-items: center;
}
</style>
  